import { Box } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import {
  BottomSheet,
  BottomSheetIllustrationContent,
  useModalState,
} from "@src/appV2/redesign/system/ui-components";
import { formatTimeWithTimezone } from "@src/appV2/redesign/utils/formatTimeWithTimezone";
import { useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { DialogFooter } from "../../../components/DialogFooter";
import { hasLocationStateBooleanKey } from "./utils/hasLocationStateBooleanKey";

interface LateClockOutInstructionsBottomSheetProps {
  scheduledClockOutTime: Date;
  workplaceTimezone: string;
}

export function LateClockOutInstructionsBottomSheet(
  props: LateClockOutInstructionsBottomSheetProps
) {
  const { scheduledClockOutTime, workplaceTimezone } = props;
  const modalState = useModalState("open");
  const history = useHistory();
  const location = useLocation();

  const onClose = useCallback(() => {
    if (hasLocationStateBooleanKey(location.state, "justClockedIn")) {
      const { justClockedIn: _justClockedIn, ...restState } = location.state;
      history.replace(location.pathname, restState);
    }
  }, [history, location.pathname, location.state]);

  const formattedScheduledClockOutTime = formatTimeWithTimezone(
    scheduledClockOutTime,
    workplaceTimezone,
    false
  );

  return (
    <BottomSheet canDismiss modalState={modalState} onClose={onClose}>
      <Box>
        <BottomSheetIllustrationContent
          hasFooter
          illustrationType="clock-warning"
          title="Late Clock Out Instructions"
          description={`If you need to stay later than ${formattedScheduledClockOutTime}, you must extend your shift before that time, or your shift will end.`}
        />
        <DialogFooter orientation="vertical">
          <Button
            fullWidth={true}
            onClick={() => {
              modalState.closeModal();
              onClose();
            }}
          >
            Ok, got it.
          </Button>
        </DialogFooter>
      </Box>
    </BottomSheet>
  );
}
